function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.495 0H.394C.176 0 0 .187 0 .417v19.166c0 .23.176.417.394.417h18.101c.218 0 .394-.187.394-.417V.417c0-.23-.176-.417-.394-.417zm-.393.833v18.334H.787V.833h17.315z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.26 4.444c.224 0 .407.25.407.556 0 .273-.144.5-.335.547l-.073.009H4.852c-.225 0-.408-.25-.408-.556 0-.273.145-.5.335-.547l.073-.009h11.407zM16.265 6.667c.222 0 .402.248.402.555 0 .273-.142.5-.33.547l-.072.009H2.623c-.221 0-.4-.249-.4-.556 0-.273.141-.5.328-.546l.072-.01h13.642zM16.265 8.889c.222 0 .402.249.402.555 0 .273-.142.5-.33.547l-.072.009H2.623c-.221 0-.4-.249-.4-.556 0-.272.141-.5.328-.546l.072-.01h13.642zM16.265 12.222c.222 0 .402.249.402.556 0 .273-.142.5-.33.546l-.072.01H2.623c-.221 0-.4-.25-.4-.556 0-.273.141-.5.328-.547l.072-.009h13.642zM8.472 14.444c.23 0 .417.25.417.556 0 .273-.148.5-.342.547l-.075.009H2.64c-.23 0-.417-.25-.417-.556 0-.273.148-.5.342-.547l.075-.009h5.833z"
}));

var SvgTermsIcon = function SvgTermsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTermsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terms_icon.b0547001.svg";
export { ForwardRef as ReactComponent };